// extracted by mini-css-extract-plugin
export default {"root":"filters_root__KbQbE"};